import React, { useContext, useState } from 'react';
import UserAvatar from 'components/user/UserAvatar';
import Button from 'components/buttons/Button';
import { LogOut } from 'react-feather';
import { Fotografija, User } from 'kzv-icons';
import useUser from 'hooks/useUser';
import { useRouter } from 'next/router';
import useSession from 'hooks/useSession';
import axios from 'data/axios';
import toast from 'react-hot-toast';
import ProfileSideNav from 'components/user/ProfileSideNav';
import ProfileTabbedNavigation from 'components/user/ProfileTabbedNavigation';
import UpdateAvatarModal from 'components/modals/UpdateAvatarModal';
import { setUserLoggingOut } from 'contexts/AppActions';
import AppContext from 'contexts/AppContext';

interface ProfileLink {
    label: string;
    href: string;
    icon?: React.FC<React.SVGProps<SVGSVGElement>>;
}

export const profileLinks: ProfileLink[] = [
    // {
    //     label: 'Moji seznami',
    //     href: '/profil',
    //     icon: Seznam
    // },
    // {
    //     label: 'Nagradni izbor',
    //     href: '/profil',
    //     icon: FotoIzbor
    // },
    {
        label: 'Moje fotografije',
        href: '/profil',
        icon: Fotografija
    },

    {
        label: 'Uredi profil',
        href: '/profil/uredi',
        icon: User
    }
];

const ProfileLayout = ({ children }: { children: React.ReactNode }) => {
    const { state, dispatch } = useContext(AppContext);
    const { user } = useUser();
    const { push } = useRouter();
    const { logout } = useSession();
    const [isAvatarModalOpen, setIsAvatarModalOpen] = useState(false);

    const handleLogout = () => {
        setUserLoggingOut(dispatch, true);
        axios
            .get('logout')
            .then(() => {
                logout();
                push('/').then(() => setUserLoggingOut(dispatch, false));
                toast.success('Uspešno si se odjavil.');
            })
            .catch(() => {
                setUserLoggingOut(dispatch, false);
                toast.error('Odjava ni bila mogoča. Osvežujem stran ...');
                window.location.reload();
            });
    };

    //TODO: Show loader if user is not loaded yet
    if (!user) return null;

    return (
        <div className="pt-6 md:pt-12 pb-24">
            <div className="container flex flex-col md:flex-row md:gap-12 lg:gap-24">
                <div className="div">
                    <div className="flex gap-4">
                        <button className="flex-shrink-0 relative" onClick={() => setIsAvatarModalOpen(true)}>
                            <UserAvatar size={'large'} clickable />
                        </button>
                        <div>
                            <h1 className="text-2xl">{user.first_name + ' ' + user.last_name}</h1>
                            {user.municipality && <p>{user.municipality.name}</p>}
                            <div className="mt-1 text-xs md:hidden">
                                <Button
                                    styles={'pl-0'}
                                    startIcon={<LogOut size={14} />}
                                    variant={'text'}
                                    color={'secondary'}
                                    disabled={state.user.loggingOut}
                                    onClick={() => handleLogout()}
                                >
                                    Odjava
                                </Button>
                            </div>
                        </div>
                    </div>
                    <div className="hidden md:block mt-8">
                        <ProfileSideNav />
                    </div>
                    <div className="md:hidden mt-4">
                        <ProfileTabbedNavigation />
                    </div>

                    <div className="mt-8 text-sm hidden md:block">
                        <Button
                            startIcon={<LogOut size={16} />}
                            variant={'text'}
                            color={'secondary'}
                            disabled={state.user.loggingOut}
                            onClick={() => handleLogout()}
                        >
                            Odjavi se
                        </Button>
                    </div>
                </div>
                <div className="flex-grow">{children}</div>
                <UpdateAvatarModal open={isAvatarModalOpen} handleClose={() => setIsAvatarModalOpen(false)} />
            </div>
        </div>
    );
};

export default ProfileLayout;
